var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-title"},[_c('span',[_vm._v("welcome to")]),_c('span',{staticClass:"keyspaceName"},[_vm._v(_vm._s(` ${_vm.$route.params.keyspace}`))]),_c('span',{staticClass:"tableName"},[_vm._v(_vm._s(` ${_vm.$route.params.table}`))]),_c('span',[_vm._v(_vm._s('! :)'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }